import {Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {ControlContainer, NgForm, NgModelGroup} from '@angular/forms';
import * as _ from 'lodash';
import {ObjetivoService} from "../../../services/objetivo/objetivo.service";
import {ComboObjetivo} from "../../../core/combo-objetivo";


@Component({
    selector: 'combo-objetivo',
    templateUrl: './combo-objetivo.component.html',
    styleUrls: ['./combo-objetivo.component.css'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm},
        {provide: ControlContainer, useExisting: forwardRef(() => NgModelGroup)}],
})
export class ComboObjetivoComponent implements OnInit {

    @ViewChild('comboObjetivo', {static: false}) comboObjetivo;

    @Input() showDisplayId;
    @Input() obrigatorio;
    @Input() selecionado;
    @Input() desabilitado;

    @Output() valorChange = new EventEmitter();

    dados = [];
    data: any = {};

    constructor(private objetivoService: ObjetivoService) {
    }

    ngOnInit(): void {
        this.data = Math.random();

        setTimeout(() => {
            this.objetivoService.getAllCombo().subscribe((objetivos: ComboObjetivo[]) => {
                this.dados = objetivos;
                this.preencherCombo();
            });
        }, 0)

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["selecionado"] && this.selecionado && this.selecionado.idObjetivo) {
            this.preencherCombo();
        }
    }

    private preencherCombo() {
        if (this.selecionado && this.selecionado.idObjetivo && this.dados.length) {
            this.selecionado = _.find(this.dados, {idObjetivo: this.selecionado.idObjetivo});
        }
    }

    onValorChange(registro: any) {
        this.valorChange.emit(registro);
        this.preencherCombo();
    }

}
